import { Grid, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import SmartAppPreview from "./components/SmartAppPreview";
import { observer } from "mobx-react-lite";
import SmartApp from "../../components/apps/SmartApp";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { SmartManagerBlack } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import Svg from "e.sic-platform.webclient/src/components/svg/Svg";
import { useNavigate } from "react-router-dom";

export default observer(function HomePage() {
  const navigate = useNavigate();
  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const [sms, setSms] = useState([3.0, 3.0, 3.0, 6.0]);

  const goToVideoConversion = useCallback(() => {
    navigate("/video-conversion");
  }, []);

  const goToPlatform = useCallback(() => {
    const configString = sessionStorage["config-storage"];
    var configStorage = JSON.parse(configString);
    openInNewTab(configStorage.platform_url);
  }, []);

  const goToVideoAnalysis = useCallback(() => {
    navigate("/video-analysis");
  }, []);

  const goToVideoSegmentation = useCallback(() => {
    navigate("/video-segmentation");
  }, []);

  return (
    <>
      <Grid container spacing={2} sx={{ padding: 4 }} className="centered">
        <Grid item xs={12} className="centered">
          <Typography variant="h4" sx={{ marginBottom: 2 }}>
            {translationService.translate("general.smartApps.title")}
          </Typography>
        </Grid>
        <Grid item xs={8} className="centered">
          <Typography
            align="center"
            variant="body1"
            color="GrayText"
            sx={{ marginBottom: 3 }}
          >
            {translationService.translate("general.smartApps.description")}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ padding: 4 }} className="centered">
        <Grid
          onMouseEnter={() => setSms([3.3, 3.0, 3.0, 6.0])}
          onMouseLeave={() => setSms([3.0, 3.0, 3.0, 6.0])}
          item
          xs={12}
          lg={sms[0]}
          sm={4}
          className="grid-item"
        >
          <SmartAppPreview
            title={"general.apps.video-conversion.title"}
            image="images/video-conversion.png"
            description={"general.apps.video-conversion.description"}
            action={goToVideoConversion}
            fontSizeMul={sms[0] / 3}
            name={ActivityTypes.VideoConversion}
          />
        </Grid>
        <Grid
          onMouseEnter={() => setSms([3.0, 3.3, 3.0, 6.0])}
          onMouseLeave={() => setSms([3.0, 3.0, 3.0, 6.0])}
          item
          xs={12}
          lg={sms[1]}
          sm={4}
          className="grid-item"
        >
          <SmartAppPreview
            title={"general.apps.video-analysis.title"}
            image="images/video-analysis.png"
            description={"general.apps.video-analysis.description"}
            action={goToVideoAnalysis}
            fontSizeMul={sms[1] / 3}
            name={ActivityTypes.VideoAnalysis}
          />
        </Grid>
        <Grid
          onMouseEnter={() => setSms([3.0, 3.0, 3.3, 6.0])}
          onMouseLeave={() => setSms([3.0, 3.0, 3.0, 6.0])}
          item
          xs={12}
          lg={sms[2]}
          sm={4}
          className="grid-item"
        >
          <SmartAppPreview
            title={"general.apps.video-segmentation.title"}
            image="images/video-segmentation.png"
            description={"general.apps.video-segmentation.description"}
            action={goToVideoSegmentation}
            fontSizeMul={sms[2] / 3}
            name={ActivityTypes.HighlightDetection}
          />
        </Grid>

        <Grid item xs={4} sm={12}></Grid>
        <Grid
          onMouseEnter={() => setSms([3.0, 3.0, 3.0, 6.6])}
          onMouseLeave={() => setSms([3.0, 3.0, 3.0, 6.0])}
          item
          xs={12}
          lg={sms[3]}
          sm={12}
          className="grid-item"
        >
          <SmartAppPreview
            title={"general.apps.platform.title"}
            image={<Svg svg={SmartManagerBlack} />}
            description={"general.apps.platform.description"}
            action={goToPlatform}
            hasPadding={true}
            fontSizeMul={sms[3] / 6}
          />
        </Grid>
      </Grid>
    </>
  );
});
